var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFuel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Gas-Station--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Gas Station Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.8321 0.445301c0.3063 0.459529 0.1821 1.080399 -0.2774 1.386749l-1.2 0.8 -0.0178 0.01161C21.5307 3.15668 21 4.13547 21 5.1v1.58005h0.5c0.5523 0 1 0.44772 1 1 0 0.55229 -0.4477 1 -1 1H21V21.2c0 1.5393 -1.376 2.99 -3.145 2.6898 -1.4732 -0.1822 -2.355 -1.4836 -2.355 -2.7898V8.4c0 -0.24772 -0.2523 -0.5 -0.5 -0.5h-0.9747L14.1 22.1c0 1 -0.8 1.8001 -1.8 1.8001H1.8C0.8 23.9001 0 23.1 0 22.1V3.10004c0 -1 0.8 -1.79999 1.8 -1.79999h10.4c1 0 1.8 0.79999 1.8 1.79999L14.0147 5.9H15c1.3523 0 2.5 1.14772 2.5 2.5v12.7c0 0.4836 0.3044 0.7721 0.6104 0.8061 0.023 0.0026 0.0458 0.0059 0.0685 0.01 0.4147 0.0754 0.8211 -0.2652 0.8211 -0.7161V5.1c0 -1.63174 0.8653 -3.24929 2.2536 -4.137586l1.1917 -0.794465c0.4595 -0.306352 1.0804 -0.182177 1.3868 0.277352ZM2.8 4.50006v3c0 0.3 0.2 0.5 0.5 0.5h7.5c0.3 0 0.5 -0.2 0.5 -0.5v-3c0 -0.3 -0.2 -0.5 -0.5 -0.5H3.3c-0.3 0 -0.5 0.2 -0.5 0.5Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFuel);
export default ForwardRef;